<template>
	<div class="mainWrapper addPI">
		<h1>Create Purchase Invoice</h1>
		<div class="po-details" v-if="po">
			<div class="first-row">
				<div class="details"><span>PO NUMBER</span> <br />{{ po.purchase_order.code }}</div>
				<div class="details">
					<span>SHOP</span> <br />
					{{ po.purchase_order.shop.name }}
				</div>
				<div class="details">
					<span>BRAND</span> <br />
					{{ po.purchase_order.brand.name }}
				</div>
				<div class="details">
					<span>REQUESTED BY</span> <br />
					{{ po.purchase_order.author.name }}
				</div>
				<div class="details">
					<span>CREATED</span> <br />
					{{ convertTime(po.purchase_order.createdAt) }}
				</div>
			</div>

			<div class="first-row">
				<div class="details">
					<span>Received Date</span> <br />
					<b-datepicker :date-formatter="dateFormatter" v-model="piReceivedDate" icon="calendar-today"> </b-datepicker>
				</div>
			</div>

			<div class="list">
				<div class="poItemList header">
					<div>BD CODE</div>
					<div>BARCODE</div>
					<div>PRODUCT NAME</div>
					<div>REQUESTED QUANTITY</div>
					<div>REMARK</div>
				</div>

				<div v-for="(item, index) of po.purchase_order_items" v-bind:key="index" class="poItemList">
					<div>{{ item.product.bd_code }}</div>
					<div>{{ item.product.barcode }}</div>
					<div>{{ item.product.name }}</div>

					<div>
						<input name="qtyInput" class="qtyInput" type="number" v-on:change="update(index, 'qty', $event.target.value)" v-bind:value="item.qty" />
					</div>

					<div>
						<textarea name="remark" class="remark" placeholder="Remark" v-model="item.remark" />
					</div>
				</div>
			</div>

			<div class="po-detail-buttons-wrapper">
				<div class="align-left">
					<b-button type="is-dark" icon-left="arrow-left" @click="back()">BACK</b-button>
				</div>
				<div class="align-right">
					<button class="big-button" @click="save()">SAVE</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AddPurchaseInvoice',
	data: function() {
		return {
			poId: this.$route.params.id, // id from get url
			po: null, // PO details
			receivedDate: [], // Receiving date
			piReceivedDate: null
		}
	},
	mounted: async function() {
		var data = {
			id: this.poId,
			populate_purchase_order: ['author', 'supplier', 'shop', 'brand'],
			populate_purchase_order_item: ['product']
		}

		const apiGetPO = await this.$api.getPODetail({ data })

		apiGetPO.data.purchase_order_items.map(item => {
			item.date = null
			item.remark = null
		})

		this.po = apiGetPO.data
	},
	methods: {
		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		update: function(index, item, value) {
			if (item == 'qty') {
				this.po.purchase_order_items[index].qty = Number(value)
			}
		},

		// Save
		save: async function() {
			const purchase_invoice_items = []

			if (!this.piReceivedDate || this.piReceivedDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Received Date',
					text: 'Received date is required!'
				})

				return
			}

			this.po.purchase_order_items.map(item => {
				const tempItems = {}
				tempItems.product = item.product._id
				// tempItems.received_date = this.$moment(this.receivedDate[index]).format("x");
				tempItems.received_date = this.$moment(this.piReceivedDate).format('DD/MM/YYYY')
				tempItems.supplier = this.po.purchase_order.supplier._id
				tempItems.qty = item.qty

				if (item.remark) {
					tempItems.remark = item.remark
				}

				purchase_invoice_items.push(tempItems)
			})

			console.log(purchase_invoice_items)

			var data = {
				purchase_order: this.po.purchase_order._id,
				purchase_invoice_items
			}

			const apiCreatePI = await this.$api.createPI({ data })

			if (apiCreatePI !== undefined) {
				this.$swal.fire({
					position: 'top-end',
					icon: 'success',
					title: 'Purchase Invoice has been created!',
					showConfirmButton: false,
					timer: 1500
				})

				this.$router.push({ name: 'pi' })
			}
		},

		// Back button
		back: function() {
			this.$router.go(-1)
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
@import '../styles/AddPI.css';
</style>
